import NewsletterTwentyTwoContainer from "./containers/NewsletterTwentyTwoContainer";
export default NewsletterTwentyTwoContainer;
